



































import { Component, Vue } from 'vue-property-decorator'

import 'semantic-ui-css/components/container.min.css'
import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/placeholder.min.css'
import 'semantic-ui-css/components/grid.min.css'

import Hls from 'hls.js'
import Plyr from 'plyr'
import 'plyr/dist/plyr.css'
import Api from '@/data/api'
import Images from '@/data/images'

const api = new Api()

function contains (where: string[], what: string): boolean {
  let contains = false
  where.forEach(itm => {
    if (itm === what) {
      contains = true
    }
  })
  return contains
}

@Component
export default class LCLivestream extends Vue {
  imgs = Images
  loading = true
  supported = true
  offline = false
  autoCatchUp = false
  accepted = window.localStorage.getItem('over_18') === 'yes'

  get name () {
    return this.$route.params[1]
  }

  get source () {
    return `${process.env.VUE_APP_STREAM_API_URL}/${this.name}/playlist.m3u8`
  }

  accept () {
    window.localStorage.setItem('over_18', 'yes')
    this.accepted = true
  }

  catchUp (plr: any) {
    if (plr.duration - plr.currentTime > 5 && plr.playing && this.autoCatchUp) {
      plr.forward((plr.duration - plr.currentTime) - 3)
    }
  }

  mounted () {
    const ctx = this
    api.getActiveStreams()
      .then(function (data) {
        if (!contains(data.streams, ctx.name)) {
          ctx.loading = false
          ctx.offline = true
        } else {
          if (!Hls.isSupported()) ctx.supported = false
          else {
            document.title = 'Lucia\'s Cipher - ' + ctx.name.toUpperCase() + '\'s Livestream'
            const video = ctx.$refs.stream as HTMLVideoElement
            const hls = new Hls()
            hls.loadSource(ctx.source)
            hls.attachMedia(video)
            const player = new Plyr('#' + video.id, {}) as any
            setInterval(() => {
              ctx.catchUp(player)
            }, 1000)
            ctx.loading = false
          }
        }
      })
  }
}
